<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NOTIFICATIONTITLE')">
        <inputvalidation :formerror="formError" name="title">
          <b-form-input type="text" v-model="formData.title"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NOTIFICATIONTEXT')">
        <inputvalidation :formerror="formError" name="text">
          <b-form-textarea v-model="formData.text" type="text" :rows="3" :max-rows="6"></b-form-textarea>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
    name: 'NotificationModal',
    props: ['formData', 'formError'],
};
</script>
